export const appeal: { [key: string]: string } = {
  appealTypeName: "Название услуги (обращения)",
  responseDate: "Дата получения",
  id: "Номер документа",
  isActual: "Действительно",
};
